import { memo, type ReactElement } from 'react'

function RecurringPaymentsIcon (): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="#FFF" fillRule="nonzero" transform="translate(-24 -298)">
          <g transform="translate(0 80)">
            <g transform="translate(0 97)">
              <g transform="translate(24 121)">
                <path
                  className="fill-current text-wpy-gray"
                  d="M9.467 13.511c-.49-.089-.89-.267-1.223-.578a1.851 1.851 0 01-.466-.844.551.551 0 01.533-.689h.022a.53.53 0 01.534.422.844.844 0 00.289.511c.222.2.488.29.822.29.355 0 .622-.09.8-.245.2-.156.289-.4.289-.69a.905.905 0 00-.267-.666c-.178-.178-.467-.333-.867-.466-.666-.223-1.155-.49-1.489-.8-.333-.312-.488-.756-.488-1.29 0-.51.155-.933.466-1.266a2.129 2.129 0 011.134-.578.195.195 0 00.155-.2v-.489c0-.2.156-.377.378-.377h.022c.2 0 .378.155.378.377v.511c0 .09.067.178.155.178.467.09.823.311 1.112.645a2 2 0 01.377.822.568.568 0 01-.555.667h-.022A.569.569 0 0111 8.31a1.103 1.103 0 00-.222-.489.895.895 0 00-.711-.355c-.311 0-.556.089-.711.244-.156.178-.245.4-.245.689a.89.89 0 00.245.644c.177.178.466.334.91.49.667.244 1.156.51 1.467.822.334.31.49.733.49 1.288 0 .556-.156.978-.49 1.29-.289.288-.689.466-1.177.555a.195.195 0 00-.156.2v.378c0 .2-.156.377-.378.377a.375.375 0 01-.378-.377v-.378c0-.089-.088-.156-.177-.178zm-4.578-.178c-.245 0-.445.2-.445.445v3.444C2.222 15.49.89 12.822.89 10 .889 4.978 4.978.889 10 .889A.446.446 0 0010 0C4.489 0 0 4.489 0 10a10.03 10.03 0 003.711 7.778H.444c-.244 0-.444.2-.444.444 0 .245.2.445.444.445H4.89c.244 0 .444-.2.444-.445v-4.444c0-.245-.2-.445-.444-.445zm11.4-11.11h3.267a.446.446 0 000-.889H15.11c-.244 0-.444.2-.444.444v4.444c0 .245.2.445.444.445.245 0 .445-.2.445-.445V2.778A9.095 9.095 0 0119.11 10c0 5.022-4.089 9.111-9.111 9.111A.446.446 0 0010 20c5.511 0 10-4.489 10-10a10.03 10.03 0 00-3.711-7.778z"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default memo(RecurringPaymentsIcon)
